export default __webpack_public_path__ + "static/media/monocarton-big.b444cfb8.png";